"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CreateUserDialog = _interopRequireDefault(require("./CreateUserDialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CreateAdminDialog = function CreateAdminDialog(props) {
  return /*#__PURE__*/_react["default"].createElement(_CreateUserDialog["default"], props);
};

CreateAdminDialog.propTypes = {};
CreateAdminDialog.defaultProps = {};
var _default = CreateAdminDialog;
exports["default"] = _default;